import { createSlice } from '@reduxjs/toolkit'
import { 
  availableBedsList, 
  reservedBedsList, 
  occupiedBedsList,
  occupiedAuditTrailBedsList,
  occupyBed, 
  reserveBed, 
  occupyReserveBed,
  extendEdd,
  modifyEdd,
  releaseReservedBed,
  releaseOccupiedBed,
  } from '../actions/bedsAction'

export const beds = createSlice({
  name: 'beds',
  initialState: {
    availableBeds: null,
    reserveBeds: null,
    occupiedBeds: null,
    auditTrails:null,
    error: null,
    isLoader: false,
    isBedRecordUpdated: false,
    isRecordLoaded:false,
  },
  reducers: {
    bedReset: state => {
       state.availableBeds= null;
       state.reserveBeds= null;
       state.occupiedBeds= null;
       state.auditTrails =null;
      state.error = null;
    },

   
    resetPopup: state => {
      state.isLoader= false;
      state.isBedRecordUpdated =false;
      state.error=null;
    },
  },
  extraReducers: {
    [availableBedsList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },

    [availableBedsList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.availableBeds= payload?.data;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
      
    },

    [availableBedsList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
    },

    [reservedBedsList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },

    [reservedBedsList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.reservedBeds= payload?.data;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },

    [reservedBedsList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },

    [occupiedBedsList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },

    [occupiedBedsList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.occupiedBeds= payload?.data;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },

    [occupiedBedsList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },
    [occupiedAuditTrailBedsList.pending]: (state, payload) => {
      state.error=null;
      state.isLoader= true;
    },
    [occupiedAuditTrailBedsList.fulfilled]: (state, {payload}) => {
      state.error=null;
      state.auditTrails= payload?.data?.auditTrails;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },
    [occupiedAuditTrailBedsList.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isLoader= false;
      state.isBedRecordUpdated =false;
    },
    [occupyBed.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [occupyBed.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [occupyBed.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

    [reserveBed.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [reserveBed.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;

    },
    [reserveBed.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

    [occupyReserveBed.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [occupyReserveBed.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [occupyReserveBed.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

    [extendEdd.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [extendEdd.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [extendEdd.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },
    [modifyEdd.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [modifyEdd.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [modifyEdd.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

    [releaseReservedBed.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [releaseReservedBed.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [releaseReservedBed.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

    [releaseOccupiedBed.pending]: (state, payload) => {
      state.error=null;
      state.isBedRecordUpdated =false;
      state.isLoader= true;
    },
    [releaseOccupiedBed.fulfilled]: (state, {payload}) => {  
      state.error=null; 
      state.isBedRecordUpdated =true;
      state.isLoader= false;
    },
    [releaseOccupiedBed.rejected]: (state, {payload}) => {
      state.error= payload;
      state.isBedRecordUpdated =false;
      state.isLoader= false;
    },

  }
})

// Action creators are generated for each case reducer function
export const { bedReset, resetPopup } = beds.actions


export default beds.reducer